export default __webpack_public_path__ + "static/media/photo8.09e5e630.jpg";